export const calculateGiftCard = (totalFinanced) => {
  // Calculate the gift card amount based on the total financed amount
  const giftCardAmount =
    totalFinanced >= 0 && totalFinanced < 2000
      ? 0
      : totalFinanced >= 2000 && totalFinanced < 4000
      ? 100
      : totalFinanced >= 4000 && totalFinanced < 6000
      ? 200
      : totalFinanced >= 6000 && totalFinanced < 10000
      ? 300
      : 500;
  // Format the gift card amount to a string with two decimal places
  const formattedGiftCardAmount =
    giftCardAmount === 0 ? 0 : `$${giftCardAmount.toFixed(2)}`;

  return formattedGiftCardAmount;
};
